import { Component, OnInit } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatSidenavModule } from "@angular/material/sidenav";
import { Router, RouterModule } from "@angular/router";
import { LocalStorageService } from "../../services/local-storage.service";

@Component({
    selector: "app-site-nav",
    standalone: true,
    imports: [RouterModule, MatSidenavModule, MatIconModule, MatListModule, MatExpansionModule],
    templateUrl: "./site-nav.component.html",
    styleUrls: ["./site-nav.component.scss"],
})
export class SiteNavComponent implements OnInit {
    activeRoute = "";

    readonly PRODUCTS = [
        {
            route: "dp",
            label: "DP",
            subProducts: [
                {
                    route: "dp/claims",
                    label: "Claims",
                    icon: "receipt",
                },
            ],
        },
        {
            route: "shopee-food",
            label: "Shopee Food",
            subProducts: [
                {
                    route: "shopee-food/claims",
                    label: "Claims",
                    icon: "receipt",
                },
                {
                    route: "shopee-food/declarations",
                    label: "Declaration",
                    icon: "verified",
                },
            ],
        },
        {
            route: "foodpanda",
            label: "foodpanda",
            subProducts: [
                {
                    route: "foodpanda/claims",
                    label: "Claims",
                    icon: "receipt",
                },
                {
                    route: "foodpanda/declarations",
                    label: "Declaration",
                    icon: "verified",
                },
            ],
        },
        {
            route: "celcomdigi",
            label: "CelcomDigi",
            subProducts: [
                {
                    route: "celcomdigi/claims",
                    label: "Claims",
                    icon: "receipt",
                },
                {
                    route: "celcomdigi/declarations",
                    label: "Declaration",
                    icon: "verified",
                },
            ],
        },
        {
            route: "shopee-express",
            label: "Shopee Express",
            subProducts: [
                {
                    route: "shopee-express/claims",
                    label: "Claims",
                    icon: "receipt",
                },
                {
                    route: "shopee-express/declarations",
                    label: "Declaration",
                    icon: "verified",
                },
            ],
        },
        {
            route: "tts",
            label: "TikTok Shop",
            subProducts: [
                {
                    route: "tts/claims",
                    label: "Claims",
                    icon: "receipt",
                },
                {
                    route: "tts/declarations",
                    label: "Declaration",
                    icon: "verified",
                },
            ],
        },
    ];

    constructor(
        private router: Router,
        private localStorageService: LocalStorageService,
    ) {}

    ngOnInit(): void {
        this.activeRoute = this.router.url.split("/")?.[1];
    }
}
